import axios from 'axios'

class TipoDocumentoApiClient {
	URL_PATH = '/ata-registro-preco/api/public/tipos-documento'

	async buscarTiposDocumento() {
		return await axios.get(`${this.URL_PATH}`)
	}
}

export default new TipoDocumentoApiClient()
